<div role="contentinfo" class="footer text-white text-center">
  <div class="footer-quicklinks bg-black w-100 d-none d-lg-block"></div>
  <div class="footer-quicklinks-mobile bg-black w-100 d-block d-lg-none"></div>
  <div class="footer-text bg-primary text-white d-flex align-items-center justify-content-center w-100">
    <div class="footer-content mt-3 d-none d-lg-block">
      <img alt="" class="footer-logo mb-2" src="assets/images/club-logo.png" draggable="false" />
      <p
        class="footer-club-rights font-size-14 mt-2 text-center"
        [innerHTML]="'nav.club.rights' | translate | markdownTranslate"
      ></p>
    </div>
    <div class="footer-content mt-2 d-block d-lg-none">
      <img alt="" class="footer-logo mb-2" src="assets/images/club-logo.png" draggable="false" />
      <p
        class="footer-club-rights text-white font-size-14 ps-3 text-center"
        [innerHTML]="'nav.club.rights' | translate | markdownTranslate"
      ></p>
    </div>
  </div>
</div>
